/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import { EventProxy } from "../../core/event-proxy";
import type { IHittable } from "../../core/ihittable";
import { Item } from "../../core/item";
import type { Player } from "../../core/player";
import type { HitObject } from "../../physics/hit-object";
import type { Table } from "../../table-model";
import type { SurfaceData } from "./surface-data";
import { SurfaceHitGenerator } from "./surface-hit-generator";

/**
 * A wall. The outline is a closed list of drag points. A wall never moves.
 */
export class Surface extends Item<SurfaceData> implements IHittable {
  private readonly hitGenerator: SurfaceHitGenerator;
  private hits: HitObject[] = [];

  // public getters
  get heightTop() {
    return this.data.heightTop;
  }

  public constructor(data: SurfaceData) {
    super(data);
    this.hitGenerator = new SurfaceHitGenerator(this, data);
  }

  public isCollidable(): boolean {
    return this.data.isCollidable;
  }

  public setupPlayer(player: Player, table: Table): void {
    this.events = new EventProxy(this, "wall", player.getEventSink());
    this.hits = this.hitGenerator.generateHitObjects(this.events, player.getPhysics(), table);
  }

  public getHitShapes(): HitObject[] {
    return this.hits;
  }
}
